import React from 'react';
import { Search, User, Sun, Moon } from 'lucide-react';
import NotificationDropdown from '../../notifications/components/NotificationDropdown';

const Topbar = ({ title = "Dashboard", logo = null, theme = "dark", setTheme }) => {
  return (
    <header className="h-16 bg-[#06070a]/80 backdrop-blur-md border-b border-white/5 fixed top-0 right-0 left-0 md:left-64 z-40 px-4 md:px-8 flex items-center justify-between transition-all duration-300">
      
      {/* Left: Page Title */}
      <div className="flex items-center gap-3">
        {logo ? (
          <div className="w-8 h-8 rounded-full overflow-hidden border border-white/10 shadow-sm">
            <img src={logo} alt="Shop Logo" className="w-full h-full object-cover" />
          </div>
        ) : (
          <div className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center border border-white/10 shadow-sm">
             <User size={16} className="text-gray-400" />
          </div>
        )}
        <h1 className="text-xl font-bold text-white tracking-tight">{title}</h1>
      </div>

      {/* Right: Actions */}
      <div className="flex items-center gap-3 md:gap-6">
        
        {/* Search (Optional - visual only) */}
        <div className="hidden md:flex items-center bg-white/5 border border-white/10 rounded-full px-4 py-2 w-64 focus-within:ring-2 focus-within:ring-[#FF0057]/20 focus-within:border-[#FF0057] transition-all group">
           <Search size={16} className="text-gray-400 group-focus-within:text-[#FF0057] transition-colors" />
           <input 
             type="text" 
             placeholder="Search orders, products..." 
             className="bg-transparent border-none outline-none text-sm ml-2 w-full text-white placeholder-gray-500"
           />
         </div>

        <div className="h-8 w-px bg-white/5 hidden md:block"></div>

        {/* Theme Toggle Button */}
        {(() => {
          const isLight = theme === 'cream' || theme === 'light' || theme === 'theme-cream' || theme === 'theme-light';
          return (
            <button
              onClick={() => setTheme(isLight ? 'dark' : 'cream')}
              className="p-2 rounded-xl bg-white/5 hover:bg-white/10 text-gray-400 hover:text-white transition-all border border-white/5 flex items-center justify-center"
              title={isLight ? 'Switch to Dark Theme' : 'Switch to Light Theme'}
            >
              {isLight ? (
                <Moon size={18} className="text-[#8C6239] fill-[#8C6239]" />
              ) : (
                <Sun size={18} className="text-yellow-400" />
              )}
            </button>
          );
        })()}

        {/* Notifications */}
        <NotificationDropdown />

      </div>
    </header>
  );
};

export default Topbar;
